// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XvCx","rootMobile":"styles_rootMobile__3ghiY"};